const routes = [
  {
    path: "/marketing/campaign_gallery",
    name: "campaign_gallery",
    component:  () => import(/* webpackChunkName: "CampaignsGallery" */ "./views/CampaignsGallery"),    
    children: [
      {
        path: "*",
        redirect: { name: "campaign_gallery"}
      }
    ]
  },
  {
    path: "/marketing/campaign_preview",
    name: "campaign_preview",
    component:  () => import(/* webpackChunkName: "CampaignPreview" */ "./views/CampaignPreview"),
    children: [
      {
        path: "*",
        redirect: { name: "campaign_gallery"}
      }
    ]
  }
];
export default routes;
